import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, submit, Form } from 'redux-form/immutable';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import _ from 'lodash';
import { renderSelect, renderTextField, renderToggle } from '../../../../utils/reduxforms';

import ReduxDialog from '../../../Common/ReduxDialog';
import styles from './styles';
import { showDialog, hideDialog } from '../../../../redux/actions/dialogs';
import { uuid } from '../../../../utils/helper';
import { QUALITY_CONTROL_QUESTION_DIALOG } from '../../../../redux/constants/dialogs';
import { getDialogContextValue } from '../../../../redux/selectors';


const QUESTION_TYPES = [
  {
    code: 'YN',
    name: 'Yes/No',
    description: 'Request user to confirm a specified action',
  }, {
    code: 'PH',
    name: 'Upload Image',
    description: 'Request user to upload image as evidence',
  },
];

const renderType = (type) => {
  return (<div style={styles.type}>
    <div style={styles.typeName}>{type.name}</div>
    <div style={styles.typeDesc}>{type.description}</div>
  </div>);
};

class QualityControlQuestionDialog extends Component {
  render() {
    const { handleSubmit, submit } = this.props;
    const actions = [
      <Button
        key="cancel"
        variant="text"
        color="primary"
        onClick={() => this.props.hideDialog(QUALITY_CONTROL_QUESTION_DIALOG)}
      >Cancel</Button>,
      <Button
        key="save"
        variant="contained"
        color="primary"
        autoFocus
        onClick={() => submit(QUALITY_CONTROL_QUESTION_DIALOG)}
      >Save</Button>,
    ];

    return (
      <ReduxDialog
        name={QUALITY_CONTROL_QUESTION_DIALOG}
        title="Quality Control Question"
        subTitle="Add items to a check list which must be completed prior to task completion"
        actions={actions}
        modal
        bodyStyle={styles.body}
      >
        <Form onSubmit={handleSubmit} style={styles.form}>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <Field
                name="question"
                component={renderTextField}
                label="Question"
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                name="type"
                component={renderSelect}
                label="Type"
                fullWidth>
                {QUESTION_TYPES.map((type) => <MenuItem
                  key={type.code}
                  value={type.code}
                  style={styles.iconItem}
                  label={type.name}
                >{renderType(type)}</MenuItem>)}
              </Field>
            </Grid>
            <Grid item xs={12}>
              <Field
                name="mandatory"
                label="Mandatory"
                style={styles.toggle}
                component={renderToggle}
              />
              <div>Choose whether this question <b>must</b> be answered to complete the QA step</div>
            </Grid>
          </Grid>
        </Form>
      </ReduxDialog>
    );
  }
}

QualityControlQuestionDialog.propTypes = {
  // question: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,

  handleSubmit: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,

  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
};

const form = reduxForm({
  form: QUALITY_CONTROL_QUESTION_DIALOG,  // a unique identifier for this form
  onSubmit: (values, dispatch, props) => {
    const question = values.toJS();
    return props.onSave(_.assign({ id: uuid() }, question));
  },
  onSubmitSuccess: (result, dispatch, props) => {
    props.hideDialog(QUALITY_CONTROL_QUESTION_DIALOG);
  },
  // onSubmitSuccess: (result, dispatch, props) => {
  //   console.log('onSubmitSuccess');
  //   props.hideDialog('jobprofile');
  // },
  // onSubmitFail: (err) => {
  //   console.log('onSubmitFail', err);
  // },
  // validate,
  // asyncValidate
  // enableReinitialize: true,
})(QualityControlQuestionDialog);

function mapStateToProps(state) {
  const context = getDialogContextValue(state);

  return {
    initialValues: context(QUALITY_CONTROL_QUESTION_DIALOG, 'question'),
    onSave: context(QUALITY_CONTROL_QUESTION_DIALOG, 'onSave'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    submit,
    showDialog,
    hideDialog,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Admin/JobProfiles/QuestionDialog/index.js